import "./index.scss";

import PrototypePage from "./pages/PrototypePage"; 

import Main from "./pages/Main";
import CreatorSessions from "./pages/creator/CreatorSessions";
import CreatorAuthorize from "./pages/creator/CreatorAuthorize";
import ConnectedAgents from "./pages/creator/ConnectedAgents";
import Session from "./pages/Session";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import Pricing from "./pages/Pricing";
import Confirmation from "./pages/Confirmation";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/authentication/Login";
import { AuthProvider, useAuth } from './context/AuthContext';
import ResetPasswordPage from "./pages/authentication/ResetPasswordPage";
import ChangePassword from "./pages/authentication/ChangePassword";
import SignUp from "./pages/authentication/SignUp";
import UpgradePage from "./pages/authentication/UpgradePage";

import './services/amplify-config'; 
import LoginPage from "./pages/authentication/LoginPage";
import Page from "./components/Page";
import { AnalyticsProvider } from "./context/AnalyticsContext";
import Contact from "./pages/Contact";
import Sessions from "./pages/Sessions";
import Demo from "./pages/Demo";
import Experiences from "./pages/Experiences";
import AccountPage from "./pages/authentication/Account";
import QuestionAnswersPage from "./pages/QuestionAnswersPage";
import HomePage from "./pages/HomePage";

import EditGuidePage from "./pages/GuideEditorPage";
import GuideEditorPage from "./pages/GuideEditorPage";
import GuidesListPage from "./pages/GuidesListPage";
import ElementsPage from "./pages/ElementsPage";
import EnvironmentsPage from "./pages/EnvironmentsPage";
import SystemsPage from "./pages/SystemsPage";
import CollectionsPage from "./pages/CollectionsPage";
import CollectionPage from "./pages/CollectionPage";
import Viewer from "./pages/Viewer";

import ProtectedRoute  from "./components/ProtectedRoute";
import Leaderboard from "./pages/Leaderboard";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import SetupDownloadsPage from "./pages/SetupDownloadsPage";
import { SETUP_DOWNLOAD_ROLES } from "./utility/accountRoles";


const App = () => {

  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<Dashboard />} /> */}
        <Route path="public/sessions/:sessionId" element={<Session />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/confirmation" element={<Confirmation />} />

        <Route path="/login" element={<LoginPage />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/iste" element={<Demo />} />
        <Route path="/signup" element={<SignUp />} />

        <Route path="reset-password" element={<ResetPasswordPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route element={<Page pricing={false} code={false} />}>
          <Route path="/" element={<ProtectedRoute />}>
            <Route index element={<HomePage />} />
            <Route path="account" element={<AccountPage />} />
            <Route path="upgrade" element={<UpgradePage />} />
          </Route>

          <Route path="/" element={<ProtectedRoute requiredPermission="viewWebContent" redirectPathPermission="/upgrade" />}>
            <Route path="viewer" element={<Viewer />} />
            <Route path="viewer/:experienceId" element={<Viewer />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={SETUP_DOWNLOAD_ROLES} />}>
            <Route path="setup" element={<SetupDownloadsPage />} />
          </Route>

          <Route path="/" element={<ProtectedRoute requiredPermission="viewAnalytics" />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="prototype" element={<PrototypePage />} />
            <Route path="question" element={<QuestionAnswersPage />} />
          </Route>

          <Route path="/" element={<ProtectedRoute requiredPermission="viewAnalytics" />}>
            <Route path="leaderboard" element={<Leaderboard />} />
          </Route>

          <Route path="/" element={<ProtectedRoute requiredPermission="crudContent" />}>
            <Route path="creator" element={<CreatorSessions />} />
            <Route path="creator/authorize" element={<CreatorAuthorize />} />
            <Route path="account/connected-agents" element={<ConnectedAgents />} />
            <Route path="elements" element={<ElementsPage />} />
            <Route path="environments" element={<EnvironmentsPage />} />
            <Route path="collections" element={<CollectionsPage />} />
            <Route path="collections/:collectionId" element={<CollectionPage />} />
            <Route path="systems" element={<SystemsPage />} />
          </Route>

          <Route path="/" element={<ProtectedRoute requiredPermission="crudExperiences" />}>
            <Route path="experiences" exact element={<Experiences />} />
          </Route>

          <Route path="/" element={<ProtectedRoute requiredPermission="viewAnalytics" />}>
            <Route path="sessions" exact element={<Sessions />} />
            <Route path="sessions/:sessionId" element={<Session dashboard={true} />} />
          </Route>

          <Route path="/" element={<ProtectedRoute requiredPermission="crudGuides" />}>
            <Route path="guides" element={<GuidesListPage />} />
            <Route path="guides/:guideId" element={<GuideEditorPage />} />
          </Route>

          
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
